import React from 'react';
import { Link } from 'react-router-dom';
import { Home, AlertCircle } from 'lucide-react';

function NotFound() {
  return (
    <div className="min-h-screen bg-white p-6 flex items-center">
      <div className="max-w-3xl mx-auto w-full">
        <div className="text-center">
          <div className="mb-8 pt-8">
            <div className="text-center mb-4">
              <img src="sell-my-car-teesside-logo.png" alt="Sell My Car Teesside Logo" className="mx-auto w-48 h-24 mb-6 object-contain" />
            </div>

            
            <h1 className="text-6xl font-bold text-slate-900 mb-2">404</h1>
            <p className="text-2xl font-semibold text-slate-700 mb-4">Page Not Found</p>
            <p className="text-slate-600 mb-8 text-lg max-w-lg mx-auto">
              Sorry, the page you're looking for doesn't exist. It may have been moved or deleted.
            </p>

            <div className="bg-white rounded-3xl p-8 shadow-xl border border-slate-200 mb-8 max-w-lg mx-auto">
              <p className="text-slate-700 mb-6">
                No worries! Let's get you back to where you need to be.
              </p>
              
              <Link 
                to="/" 
                className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg transition-colors"
              >
                <Home size={20} />
                Back to Home
              </Link>

              <div className="mt-8 pt-8 border-t border-slate-200">
                <p className="text-slate-600 mb-4 text-sm">Quick Links:</p>
                <div className="flex flex-col gap-3">
                  <Link to="/" className="text-blue-600 hover:text-blue-800 font-medium transition-colors">
                    Get your car valuation
                  </Link>
                  <Link to="/privacy-policy" className="text-blue-600 hover:text-blue-800 font-medium transition-colors">
                    Privacy Policy
                  </Link>
                  <Link to="/cookies-policy" className="text-blue-600 hover:text-blue-800 font-medium transition-colors">
                    Cookies Policy
                  </Link>
                  <Link to="/terms-and-conditions" className="text-blue-600 hover:text-blue-800 font-medium transition-colors">
                    Terms & Conditions
                  </Link>
                </div>
              </div>
            </div>

            <div className="text-center py-6">
              <p className="text-slate-500 text-sm">
                Having trouble? Contact us at <a href="mailto:teessideautos1@gmail.com" className="text-blue-600 hover:underline">teessideautos1@gmail.com</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
